export function getBrowserLocalStorage(): Storage | undefined {
  try {
    if (typeof window === 'undefined') return undefined;
    const storage = window.localStorage;
    if (!storage) return undefined;

    return typeof storage.getItem === 'function' &&
      typeof storage.setItem === 'function' &&
      typeof storage.removeItem === 'function'
      ? storage
      : undefined;
  } catch {
    return undefined;
  }
}
